import Request from '@hotmart/request'

Request.register(`${process.env.API_BUSINESS_WORKSPACE}/v1`, {
  get: {
    'bw.user.type': '/user/type'
  }
})

Request.register(`${process.env.API_PLATFORM_TOOLS}/v1`, {
  get: {
    'tools.list': '/tools',
    'search.list': '/search'
  }
})
